import { queryKeys } from '@/hooks/constants';
import { useQueryWithLogging } from '@/hooks/useQueryWithLogging';
import Service from '@/lib/App';

export function useFetchDomainsMetadata() {
  return useQueryWithLogging({
    queryKey: queryKeys.planner.getDomainsMetadata(),
    queryFn: () => Service.planner.fetchDomainMetadata(null),
    retry: 3,
  });
}
